import { render } from "./EditPartForm.vue?vue&type=template&id=a198baf4"
import script from "./EditPartForm.vue?vue&type=script&lang=js"
export * from "./EditPartForm.vue?vue&type=script&lang=js"

import "./EditPartForm.vue?vue&type=style&index=0&id=a198baf4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__